export default __webpack_public_path__ + "static/media/trash.7d45b5d4.svg";